import BASEURLGESTTOR from '../api/gesttor'
import { BASEURLGESTTORFORMDATA } from '../api/gesttor'
import { cadastroPayload, paransListCadastros, cadastrosUpdatePayload, atualizarAvatarCadastro } from '../../interfaces/cadastros'


export function novoCadastro(payload: cadastroPayload) {
    return BASEURLGESTTOR.post('/cadastros', payload)
}

export function listarCadastros(params: paransListCadastros) {

    if (params.tag) {
        return BASEURLGESTTOR.get(`/cadastros?pagina=${params.pagina}&tipo=${params.tipo}&termo=${params.termo}&situacao=${params.situacao}&tag=${params.tag}`)
    }

    return BASEURLGESTTOR.get(`/cadastros?pagina=${params.pagina}&tipo=${params.tipo}&termo=${params.termo}&situacao=${params.situacao}`)

}

export function listarCobrancas(idCadastro: string) {
    return BASEURLGESTTOR.get(`/cadastros/cobrancas/${idCadastro}`)
}

export function atualizarCadastro(payload: cadastrosUpdatePayload, idCadastro: string) {
    return BASEURLGESTTOR.patch(`/cadastros/${idCadastro}`, payload)
}

export function atualizarAvatar(idCadastro: string, payload: atualizarAvatarCadastro) {
    return BASEURLGESTTORFORMDATA.post(`/cadastros/avatar/${idCadastro}`, payload)
}
